const EventSessionType = {
    DEFAULT: 0,
    SUMMARY: 1
}
export default EventSessionType